import gsap from 'gsap';

( function( app ) {
  const COMPONENT = {
    init: function() {
      const components = document.querySelectorAll( '[data-component="scrolling-seo"]' );
      if ( !components.length ) return;

      components.forEach( ( outer ) => {
        const slides = outer.querySelectorAll( '.scrolling-seo-section' );
        if ( !slides.length ) return;

        let activeSlide = 0;

        const getTopOffset = () => {
          const val = getComputedStyle( document.documentElement ).getPropertyValue( '--topOffset' ).trim();
          if ( val.endsWith( 'rem' ) ) {
            return parseFloat( val ) * parseFloat( getComputedStyle( document.documentElement ).fontSize );
          }
          return parseFloat( val ) || 0;
        };

        const getSlideHeight = () => window.innerHeight - getTopOffset();

        const getOuterTop = () => outer.getBoundingClientRect().top + window.scrollY;

        const setOuterHeight = () => {
          outer.style.height = `${ slides.length * getSlideHeight() }px`;
        };

        const activateSlide = ( index ) => {
          slides.forEach( ( slide, i ) => {
            const content = slide.querySelector( '.scrolling-seo-section-content .wysiwyg' );
            const isActive = i === index;

            slide.classList.toggle( 'is-active', isActive );

            if ( content ) {
              if ( isActive ) {
                setTimeout( () => content.classList.add( 'is-active' ), 100 );
              } else {
                content.classList.remove( 'is-active' );
              }
            }
          } );
        };

        const goToSlide = ( newSlide ) => {
          if ( newSlide === activeSlide ) return;
          activeSlide = newSlide;
          activateSlide( activeSlide );
        };

        const snapToSlide = ( slide ) => {
          const topOffset = getTopOffset();
          const slideHeight = getSlideHeight();
          const pinStart = getOuterTop() - topOffset;
          window.scrollTo( {top: pinStart + slide * slideHeight, behavior: 'smooth'} );
        };

        const mm = gsap.matchMedia();

        mm.add( '(min-width: 768px)', () => {
          setOuterHeight();

          activateSlide( 0 );

          let snapTimer;
          let isSnapping = false;

          const handleScroll = () => {
            if ( isSnapping ) return;

            const topOffset = getTopOffset();
            const slideHeight = getSlideHeight();
            const pinStart = getOuterTop() - topOffset;
            const pinRange = ( slides.length - 1 ) * slideHeight;

            if ( pinRange <= 0 ) return;

            const scrolled = window.scrollY - pinStart;
            const progress = scrolled / pinRange;
            const clamped = Math.max( 0, Math.min( 1, progress ) );
            const newSlide = Math.round( clamped * ( slides.length - 1 ) );

            goToSlide( newSlide );

            clearTimeout( snapTimer );

            const inPinZone = scrolled >= 0 && scrolled <= pinRange;
            if ( inPinZone ) {
              snapTimer = setTimeout( () => {
                isSnapping = true;
                snapToSlide( activeSlide );
                setTimeout( () => {
                  isSnapping = false;
                }, 800 );
              }, 150 );
            }
          };

          const handleResize = () => {
            setOuterHeight();
          };

          window.addEventListener( 'scroll', handleScroll, {passive: true} );
          window.addEventListener( 'resize', handleResize );

          return () => {
            window.removeEventListener( 'scroll', handleScroll );
            window.removeEventListener( 'resize', handleResize );
            clearTimeout( snapTimer );
            outer.style.height = '';
          };
        } );

        outer._mm = mm;
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'scrolling-seo', COMPONENT );
} )( app );
